import { Link } from "react-router-dom";
import type { MangaArticle } from "@/mocks/mangaData";
import { categories } from "@/mocks/mangaData";
import { formatViews } from "@/utils/format";

export default function ArticleCard({ article }: { article: MangaArticle }) {
  const category = categories.find((c) => c.id === article.categoryId);
  return (
    <Link
      to={`/article/${article.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative aspect-[16/10] w-full overflow-hidden">
        <img
          src={article.cover}
          alt={article.title}
          className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
        />
        {article.updateInfo && (
          <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-black/60 px-2.5 py-1 text-xs font-medium text-white backdrop-blur-sm">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-accent-400" />
            {article.updateInfo}
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex items-center gap-2">
          {category && (
            <span className="rounded-md bg-primary-100 px-2 py-0.5 text-xs font-medium text-primary-700">{category.name}</span>
          )}
          <span className="text-xs text-foreground-400">{article.date}</span>
        </div>
        <h3 className="mt-2.5 line-clamp-2 text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[17px]">
          {article.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{article.excerpt}</p>
        <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3">
          <span className="text-xs text-foreground-500">{article.author}</span>
          <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-eye-line" />
            {formatViews(article.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}